import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BurnRequestDto } from 'src/app/dtos/burn-request.dto';
import { TokenService } from 'src/app/services/token.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomValidators } from 'ngx-custom-validators';
import { BurnResponseDto } from 'src/app/dtos/burn-response.dto';
import { Router } from '@angular/router';
import { DataService } from 'src/app/utils/data.service';
import { UserService } from 'src/app/services/user.service';
import { GetUserDto } from 'src/app/dtos/get-user.dto';
import { GetTokenDto } from 'src/app/dtos/get-token.dto';

@Component({
  selector: 'app-burn-from',
  templateUrl: './burn-from.component.html',
  styleUrls: ['./burn-from.component.css']
})
export class BurnFromComponent implements OnInit {

  user: GetUserDto;
  userId: string;
  form: FormGroup;
  request: BurnRequestDto;
  token: GetTokenDto;
  tokenAddress: string;

  constructor(
    private fb: FormBuilder,
    private tokenService: TokenService,
    private userService: UserService,
    private dataService: DataService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private router: Router
  ) {
    this.form = this.fb.group({
      address: ['', [Validators.required]],
      value: ['', [Validators.required, CustomValidators.number]],
    });
  }

  ngOnInit(): void {

    this.spinner.show();

    this.userId = this.userService.getUserLocalStorage();
    this.dataService.currentTokenAddress.subscribe(tokenAddress => this.tokenAddress = tokenAddress);

    this.userService
      .getByEmail(this.userId)
      .subscribe((response: GetUserDto) => {
        this.user = response;
      });

    this.tokenService
      .getByAddress(this.tokenAddress)
      .subscribe((response: GetTokenDto) => {
        this.token = response[0]
      });

      this.form = this.fb.group({
        userId: this.userId,
        tokenAddress: this.tokenAddress,
        address: ['', [Validators.required]],
        value: ['', [Validators.required, CustomValidators.number]],
      });

    this.spinner.hide();

  }

  burn() {
    this.spinner.show();

    this.request = Object.assign({}, this.form.value);

    this.tokenService.burn(this.request).subscribe(
      success => { this.runSuccess(success) },
      error => { this.runError(error) }
    );
  }

  runSuccess(success: BurnResponseDto) {
    const toastr = this.toastrService.success(`Burn success`, 'Success', {
      progressBar: true
    });

    if (toastr)
      toastr.onHidden.subscribe(() => {
        this.router.navigate(['/pages/dashboard']);
        this.spinner.hide();
      });
  }

  runError(exception: any) {
    const toastr = this.toastrService.error(exception.error.errors[0], 'Error', {
      progressBar: true
    });

    if (toastr)
      toastr.onHidden.subscribe(() => {
        this.spinner.hide();
      });
  }
}
